import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetRevisionParams extends PaginationProps {}

interface CreateRevision {
  name: string;
}

interface UpdateRevision extends CreateRevision {
  id: number | null;
}

export async function getRevisions() {
  const { data } = await api.get('/revisions');
  return data;
}

export async function getRevisionsMasterData(params: GetRevisionParams) {
  const { data } = await api.get('/revisions/master-data', {
    params
  });
  return data;
}

export async function getRevision(id: number) {
  const { data } = await api.get(`/revisions/${id}`);
  return data;
}

export async function createRevision(createRevision: CreateRevision) {
  const { data } = await api.post('/revisions', createRevision);
  return data;
}

export async function updateRevision(updateRevision: UpdateRevision) {
  const { data } = await api.put(
    `/revisions/${updateRevision.id}`,
    updateRevision
  );
  return data;
}

export function deleteRevision(id: number) {
  return api.delete(`/revisions/${id}`);
}
